import { toUpper, upperFirst } from "lodash"
import { Selection } from "../../../../src/application/Contracts";
import TankInsulation = Selection.TankInsulation;
import TankFamily = Selection.TankFamily;
import TankMaterials = Selection.TankMaterials;
import InspectionHole = Selection.InspectionHole;

export class EnumsTextHelper {
    static GetSlugFromEnum<EnumType extends { [name: string]: any }>(enumObj: EnumType, enumValue: number): string {
        let result: string = "";
        (Object.keys(enumObj) as (keyof EnumType)[]).map((key, index) => { if (index == enumValue) { result = enumObj[key]; } });
        return result;
    }

    static GetValueFromEnum<EnumType extends { [name: string]: any }>(enumObj: EnumType, enumKey: string): number {
        let result: number = 0;
        (Object.keys(enumObj) as (keyof EnumType)[]).map((key, index) => { if (key == enumKey) { result = index; } });
        return result;
    }

    static GetInsulationTextFromSlug = (slug: TankInsulation) => {
        switch (slug) {
            case toUpper(TankInsulation.ALL):
                return __("All")
            case toUpper(TankInsulation.M0):
                return __("M0")
            case toUpper(TankInsulation.M1):
                return __("M1")
            case toUpper(TankInsulation.M2):
                return __("M2")
            case toUpper(TankInsulation.NEODUL):
                return __("Neodul")
        }
    }

    static GetProductFamilyTextFromSlug = (slug: TankFamily) => {
        switch (slug) {
            case upperFirst(TankFamily.PrimaryTank):
                return __("Primary Tank")
            case upperFirst(TankFamily.AquaTank):
                return __("Aqua Tank")
        }
    }
}
